const Index = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/RelatorioEvolucaoMensal/Index')

export default [
  {
    path: 'relatorio-evolucao-mensal-financeira',
    name: 'RelatorioEvolucaoMensal',
    component: Index,
    meta: {
      title: 'Evolução Mensal Financeira',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'relatorioEvolucaoMensal',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/relatorio-evolucao-mensal.js